import React, { useEffect, useState } from "react";
import { Button, Modal, Typography } from "@mui/material";
import {
  CheckBox as CheckBoxIcon,
  Close as CloseIcon,
  Cancel as CancelIcon,
} from "@mui/icons-material";
import { format, intervalToDuration } from "date-fns";
import { useTranslation } from "react-i18next";
import { formatTaxDocument } from "utils/taxDocument";

import {
  DealerOrderState,
  OrderProps,
  OrderUpdateActions,
  OrderUpdateActionsEnum,
} from "store/modules/Orders/types.store";

import CardActions from "../CardActions";

import * as Styled from "./styles";

interface ModalOrderManagementProps {
  isOpen: boolean;
  isView?: boolean;
  onClose: () => void;
  handleOrderUpdate: (
    type: OrderUpdateActions,
    id: string,
    dealerId: string,
    paymentType: string,
    valeGas: boolean,
    consumerId: string,
  ) => void;
  data: OrderProps;
}

const ModalOrderManagement: React.FC<ModalOrderManagementProps> = ({
  isOpen,
  onClose,
  isView,
  data,
  handleOrderUpdate,
}) => {
  const { t } = useTranslation();

  // TODO: remover ate a apresenetação da Super

  const [timeRight, setTimeRight] = useState("");

  useEffect(() => {
    const intervalId = setInterval(() => {
      const time = intervalToDuration({
        start: new Date(data?.createdAt ?? Date()),
        end: new Date(Date()),
      });
      setTimeRight(
        format(
          new Date(
            time.years || 0,
            time.months || 0,
            time.days || 0,
            time.hours || 0,
            time.minutes || 0,
            time.seconds || 0,
          ),
          "HH:mm:ss",
        ),
      );
    }, 1000);
    return () => clearInterval(intervalId);
  }, [data?.createdAt]);

  return (
    <Modal open={isOpen} onClose={onClose} style={{ zIndex: 1201 }}>
      <Styled.Content>
        <Styled.ContainerHeader>
          <Styled.ContainerTitle>
            <Typography variant="caption" textAlign="start">
              {data?.consumer?.name}
            </Typography>
            <Typography variant="subtitle2" textAlign="start">
              {data?.delivery?.address.city}
            </Typography>
          </Styled.ContainerTitle>

          {/* TODO: remover ate a apresenetação da Super */}

          <Styled.ContainerStatus
            colorTheme={
              data?.consumerState !== "Finalized" ? "primary" : "secondary"
            }
          >
            <Typography
              color={
                data?.consumerState !== "Finalized" ? "primary" : "secondary"
              }
              variant="caption"
            >
              {data?.consumerState !== "Finalized"
                ? `Pendente ${timeRight}`
                : "Finalizado"}
            </Typography>
          </Styled.ContainerStatus>
        </Styled.ContainerHeader>
        <CardActions data={data as any} />

        <Typography color="caption" fontSize="small" variant="caption">
          {t("CPFOrCNPJ")}
        </Typography>

        <Typography color="caption" fontSize="small" variant="caption">
          {formatTaxDocument(data?.fiscal?.document)}
        </Typography>

        <Styled.ContainerIdTransition>
          <Typography color="caption" fontSize="small" variant="caption">
            {format(new Date(data?.createdAt), "dd - MM - yyyy - HH:mm")}
          </Typography>
          {/* TODO: FUTURE FEATURE */}
          {/* <Typography color="caption" fontSize="small" variant="caption">
            ID - {data?.id}
          </Typography> */}
        </Styled.ContainerIdTransition>

        <Styled.CantainerButtom>
          <Button
            onClick={onClose}
            color="inherit"
            variant="text"
            endIcon={<CloseIcon />}
          >
            {t("close")}
          </Button>

          {!isView && (
            <>
              <Button
                onClick={() =>
                  handleOrderUpdate(
                    data.status === "Placed"
                      ? OrderUpdateActionsEnum.DENY
                      : OrderUpdateActionsEnum.CANCEL,
                    data.id,
                    data.dealer.id,
                    data.payment.type || "",
                    data?.voucher?.valeGas || false,
                    data?.consumer?.id || "",
                  )
                }
                color="primary"
                variant="text"
                endIcon={<CancelIcon />}
              >
                {data.dealerState === DealerOrderState.NEW
                  ? t("refuse")
                  : t("cancel")}
              </Button>

              <Button
                onClick={() =>
                  handleOrderUpdate(
                    data.dealerState === DealerOrderState.NEW
                      ? OrderUpdateActionsEnum.ACCEPT
                      : OrderUpdateActionsEnum.FINALIZE,
                    data.id,
                    data.dealer.id,
                    data.payment.type || "",
                    data?.voucher?.valeGas || false,
                    data?.consumer?.id || "",
                  )
                }
                color="secondary"
                variant="text"
                endIcon={<CheckBoxIcon />}
              >
                {data.dealerState === DealerOrderState.NEW
                  ? t("toAccept")
                  : t("finish")}
              </Button>
            </>
          )}
        </Styled.CantainerButtom>
      </Styled.Content>
    </Modal>
  );
};

export default ModalOrderManagement;
